<template>
  <GlobalPrompt/>
  <GlobalSnackbar/>
</template>

<script setup lang="ts">
import GlobalPrompt from "@/components/Globals/prompt/GlobalPrompt.vue";
import GlobalSnackbar from "@/components/Globals/snackbar/GlobalSnackbar.vue";
</script>
